import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Input,
  Modal,
  Button,
  Popover,
  Layout,
  Skeleton,
  Table,
  Select,
  Pagination,
  DatePicker,
  Card,
  message,
} from "antd";
import { FaSearch, FaFilter, FaEye, FaArrowLeft } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { QUESTION, QUIZ } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import "../upcoming-lessons/upcoming-lessons.css";
import "../course-management/course-management.css";
import "./quiz-management.css";
import "./quiz-details.css";

const { Option } = Select;

function QuizAttempts() {
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [quizAttempts, setQuizAttempts] = useState([]);
  const [selectedUser] = useState(null); // eslint-disable-line no-unused-vars
  const [questions, setQuestions] = useState([]);
  const [quiz, setQuiz] = useState();
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();
  const { id } = useParams();

  const [filter, setFilter] = useState({
    status: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const paginationSummary = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  useEffect(() => {
    getAllQuiz();
    getQuizAttempts();
    getQuizById();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getQuizAttempts = async () => {
    setLoading(true);
    const res = await Get(QUIZ.getQuizAttempts + id, token, {
      limit: "100",
    });

    console.log("<<<<>>>>>", res);

    setQuizAttempts(res.data.docs);
    setLoading(false);
  };

  const getQuizById = async () => {
    setLoading(true);
    const res = await Get(`${QUIZ.getQuizById}${id}`, token, {
      limit: "100",
    });

    setQuiz(res.data.quiz);
    setLoading(false);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getAllQuiz(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      category: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      category: "",
      keyword: "",
      from: null,
      to: null,
    });
    getAllQuiz(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const handleLimitChange = (pageSize) => {
    setPaginationConfig({
      ...paginationConfig,
      limit: pageSize,
      current: 1,
    });

    getAllQuiz(1, pageSize);
  };

  const handleStatus = async () => {
    try {
      const index = questions.findIndex((user) => user._id === selectedUser._id);

      console.log(index);
      await Get(
        QUESTION.toggleStatus + "/" + selectedUser._id,
        token,
        {}
      );
      const newUsers = [...questions];

      console.log(">>>>", newUsers[index].isActive);
      console.log(">>>>", selectedUser.isActive);
      newUsers[index].isActive = !selectedUser.isActive;
      setModalOpen(false);
      setQuestions(newUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllQuiz = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(QUIZ.getQuizAttempts + id, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        category: reset ? "" : filter.category || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      console.log("response", response);
      if (response?.data?.docs) {
        setQuestions(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  console.log("paginationConfig", paginationConfig);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="upcoming-lessons-pager-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="upcoming-lessons-pager-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "_id",
      width: 120,
      key: "_id",
      render: (item) => (
        <div className="quiz-management-action-cell">
          <button
            type="button"
            className="quiz-mgmt-icon-btn"
            aria-label="View submission"
            onClick={() => navigate("/quiz-response/" + item)}
          >
            <FaEye style={{ fontSize: 16 }} />
          </button>
        </div>
      ),
    },
    {
      title: "S. No.",
      dataIndex: "key",
      key: "key",
      width: 100,
      render: (value, item, index) => (
        <span className="upcoming-lessons-cell-id">
          {(index < 10 && "0") + (index + 1)}
        </span>
      ),
    },
    {
      title: "Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (
        <span className="upcoming-lessons-cell-name">
          {item?.firstName + " " + item?.lastName}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (val) => (
        <span className="upcoming-lessons-cell-name">{val}</span>
      ),
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      render: (val) => (
        <span className="upcoming-lessons-cell-money">{val}</span>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "quizDate",
      key: "quizDate",
      render: (item) => (
        <span className="upcoming-lessons-cell-date">
          {moment(item).format("ll")}
        </span>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown upcoming-lessons-filter-popover">
      <p className="upcoming-lessons-filter-head">Filter submissions</p>
      <hr />

      <div className="filterDropdownBody">
        <p className="mainLabel">Start Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
        />

        <p className="mainLabel">Filter by attempt:</p>

        <Select
          size={"large"}
          className="filterSelectBox upcoming-lessons-filter-select"
          placeholder="Select Option"
          value={filter?.category}
          onChange={(e) => handleStatusChange(e)}
        >
          {quizAttempts.map((item) => (
            <Option key={item?._id} value={item?._id}>
              {item?.title}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          className="mainButton primaryButton loginButton upcoming-lessons-filter-apply"
          onClick={() => getAllQuiz()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          className="mainButton primaryButton2 loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout
      className="configuration upcoming-lessons-page quiz-details-page"
      style={{ minHeight: "100vh" }}
    >
      <Row className="blueBackground-old coursebnr quiz-management-hero">
        <Typography.Title
          level={1}
          className="fontFamily1 aboutbanner-content"
          style={{color:"#fff"}}
        >
          Quiz submissions
        </Typography.Title>
      </Row>

      <div className="boxDetails">
        <Row className="whiteBackground upcoming-lessons-section" style={{ justifyContent: "center" }}>
          <Col xs={24} lg={22} xl={21}>
            <div className="upcoming-lessons-inner">
              <Card className="infoBox upcoming-lessons-card" bordered={false}>
                <div className="upcoming-lessons-box">
                  <Row className="upcoming-lessons-toolbar" gutter={[16, 16]}>
                    <Col xs={24} md={16}>
                      <div className="course-management-title-block">
                        <button
                          type="button"
                          className="course-management-inline-back"
                          aria-label="Go back"
                          onClick={() => navigate(-1)}
                        >
                          <FaArrowLeft aria-hidden="true" />
                        </button>
                        <Typography.Title
                          level={2}
                          className="fontFamily1 course-management-page-title"
                          style={{ wordBreak: "break-word" }}
                        >
                          {(quiz?.title || "Quiz") + " — Submissions"}
                        </Typography.Title>
                      </div>
                    </Col>
                  </Row>

                  <Row className="course-management-sub-toolbar" gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <div className="course-management-page-size">
                        <span className="course-management-page-size-label">
                          Show
                        </span>
                        <Select
                          size={"large"}
                          className="chartSelectBox"
                          defaultValue={paginationConfig.limit}
                          onChange={(e) => handleLimitChange(e)}
                          style={{
                            width: 70,
                            textAlign: "left",
                          }}
                          options={[
                            { value: 10, label: "10" },
                            { value: 20, label: "20" },
                            { value: 30, label: "30" },
                            { value: 40, label: "40" },
                            { value: 50, label: "50" },
                          ]}
                        />
                        <span className="course-management-page-size-label">
                          entries
                        </span>
                      </div>
                    </Col>
                    <Col xs={24} md={12} className="upcoming-lessons-toolbar-actions">
                      <Popover
                        content={filterContent}
                        trigger="click"
                        open={open}
                        onOpenChange={handleOpenChange}
                        placement="bottomRight"
                        arrow={false}
                      >
                        <Button
                          type="primary"
                          shape="circle"
                          className="upcoming-lessons-filter-trigger"
                          aria-label="Open filters"
                        >
                          <FaFilter style={{ fontSize: 16, color: "white" }} />
                        </Button>
                      </Popover>
                      <Input
                        className="mainInput dashInput upcoming-lessons-search"
                        placeholder="Search submissions…"
                        onChange={(e) => handleSearch(e.target.value)}
                        suffix={
                          <FaSearch
                            style={{
                              color: "#64748b",
                              fontSize: 16,
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              getAllQuiz(1, paginationConfig.limit, filter.keyword)
                            }
                          />
                        }
                        onPressEnter={() =>
                          getAllQuiz(1, paginationConfig.limit, filter.keyword)
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="upcoming-lessons-table-shell">
                    {loading ? (
                      <div className="upcoming-lessons-skeleton-wrap">
                        <Skeleton active paragraph={{ rows: 6 }} />
                      </div>
                    ) : (
                      <div className="upcoming-lessons-table-wrap">
                        <Table
                          className="styledTable upcoming-lessons-table"
                          dataSource={quizAttempts}
                          columns={columns}
                          pagination={false}
                          rowKey={(record, index) =>
                            record._id ?? `attempt-${index}`
                          }
                          scroll={{ x: "max-content" }}
                        />
                      </div>
                    )}
                  </Row>

                  <Row className="upcoming-lessons-pagination-row" gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <p className="fontFamily1 upcoming-lessons-pagination-meta">
                        {paginationSummary}
                      </p>
                    </Col>
                    <Col xs={24} md={12}>
                      <div className="upcoming-lessons-pagination-controls">
                        <Pagination
                          className="styledPagination"
                          onChange={(e) => handlePageChange(e)}
                          current={parseInt(paginationConfig.pageNumber)}
                          pageSize={paginationConfig.limit}
                          total={paginationConfig.totalDocs}
                          itemRender={itemRender}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        open={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {selectedUser?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {selectedUser?.isActive ? "Deactivate" : "Activate"}{" "}
          This Service Provider?
        </Typography.Text>
      </Modal>
    </Layout>
  );
}

export default QuizAttempts;
